import type { CustomField } from '@/common/api/types/customField';
import { OverflowTooltip } from '@/common/components/ui/OverflowTooltip';
import { formatCurrency } from '@/common/utils/formatCurrency';
import { isFiniteNumber } from '@/common/utils/number';

export const CurrencyCell = ({
  value,
  currencyUnit,
}: { value?: number } & Pick<CustomField, 'currencyUnit'>) =>
  isFiniteNumber(value) && (
    <OverflowTooltip>{formatCurrency(value, currencyUnit ?? null)}</OverflowTooltip>
  );
